<template>
  <div class="min-h-screen bg-gray-50 px-4 pt-6 pb-28" dir="rtl">
    <div class="max-w-4xl mx-auto md:max-w-lg space-y-6">
      
      <!-- QC Items List -->
      <div v-if="pre_defined_items.length > 0" class="space-y-4">
        <div class="bg-gradient-to-r from-green-500 to-green-600 rounded-xl p-6 text-white">
          <div class="flex items-center gap-3">
            <div class="w-12 h-12 rounded-full bg-white bg-opacity-20 backdrop-blur-sm flex items-center justify-center">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div class="w-full">
              <h3 class="text-xl font-bold">کنترل کیفیت</h3>
              <p class="text-sm text-green-50">لطفاً آیتم‌های بررسی شده را انتخاب کنید</p>
            </div>
          </div>
        </div>

        <div class="bg-white rounded-xl border border-gray-200 p-6 space-y-3">
          <div 
            v-for="item in pre_defined_items" 
            :key="item.PreDefinedId"
            :class="checkbox_items.includes(item.PreDefinedId) ? 'bg-green-50 border-green-300' : 'bg-gray-50 border-gray-200'"
            class="flex items-center justify-between p-4 border rounded-lg transition-all duration-200 cursor-pointer hover:shadow-md"
            @click="toggleCheckbox(item.PreDefinedId)"
          >
            <label class="text-sm font-medium text-gray-900 cursor-pointer w-full">
              {{item.PredefinedTitle}}
            </label>
            
            <!-- Custom Checkbox -->
            <div 
              :class="checkbox_items.includes(item.PreDefinedId) ? 'bg-green-600 border-green-600' : 'bg-white border-gray-300'"
              class="w-6 h-6 border rounded-md flex flex-shrink-0 items-center justify-center transition-all duration-200"
            >
              <svg v-if="checkbox_items.includes(item.PreDefinedId)" class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-else class="bg-white rounded-xl border border-dashed border-gray-300 p-12 text-center">
        <div class="max-w-2xl mx-auto">
          <div class="w-20 h-20 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
            <svg class="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <p class="text-gray-500 font-medium mb-2">آیتمی وجود ندارد</p>
        </div>
      </div>

      <!-- Summary Textarea -->
      <div class="bg-white rounded-xl border border-gray-200 p-6">
        <div class="flex items-center gap-2 mb-3">
          <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          <label class="block text-sm font-medium text-gray-700">توضیحات</label>
        </div>
        <textarea 
          v-model="summary"
          rows="6"
          class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 resize-none"
          style="border: 1px solid #d1d5db !important;"
          :placeholder="$t('summary')"
        ></textarea>
      </div>

      <!-- Progress Summary -->
      <div v-if="pre_defined_items.length > 0" class="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl p-4">
        <div class="flex items-center justify-between text-sm">
          <div class="flex items-center gap-2 text-gray-700">
            <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span class="font-medium">پیشرفت بررسی</span>
          </div>
          <span class="font-bold text-green-600">
            {{ checkbox_items.length }} از {{ pre_defined_items.length }}
          </span>
        </div>
        <div class="mt-2 w-full bg-gray-200 rounded-full h-2">
          <div 
            class="bg-green-500 h-2 rounded-full transition-all duration-300"
            :style="{ width: `${(checkbox_items.length / pre_defined_items.length) * 100}%` }"
          ></div>
        </div>
      </div>

      <!-- Submit Button -->
      <button 
        @click="send_predifined()"
        class="w-full bg-gradient-to-r from-green-600 to-emerald-700 hover:from-green-700 hover:to-emerald-800 text-white py-4 px-6 rounded-xl font-bold transition-all duration-200 flex items-center justify-center gap-2"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        {{ $t('add_information') }}
      </button>

    </div>
  </div>
</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        checkbox_items: [],
        selected_currency: 0,
        price: '',
        summary: '',
        branch_id: 0,
        // device_serial_number: '',
        device_password: '',
        pre_defined_items: [],

        valid: true,
        not_register: false,
        user_registered: false,

      }
    },
watch: {

    },
mounted () {
      this.get_predifined()
    },
    methods: {
      toggleCheckbox(id) {
        const index = this.checkbox_items.indexOf(id);
        if (index > -1) {
          this.checkbox_items.splice(index, 1);
        } else {
          this.checkbox_items.push(id);
        }
      },
      get_predifined () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,

        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetRequestQCItems', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.pre_defined_items = response.data.items.DbQCItems;
              self.summary = response.data.items.QcSummary;
              console.log("qc items",response.data.items.QCItems)
              response.data.items.QCItems.forEach(function (val) {
                self.checkbox_items.push(val.PreDefinedId)
              });
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      send_predifined () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          QcDesc: this.summary,
          ChkList: this.checkbox_items,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddRequestQC', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])

            if (response.data.error == 0) {
              self.$router.go(-1)
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

    }
  }
</script>
